module.exports = __webpack_public_path__ + "img/transport_category_1.c26128da.svg";